"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Wave;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function Wave(_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? 200 : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? 15 : _ref$height,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "#fff" : _ref$color,
      _ref$style = _ref.style,
      style = _ref$style === void 0 ? {} : _ref$style,
      innerRef = _ref.innerRef;
  return /*#__PURE__*/_react["default"].createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 15",
    width: width,
    height: height,
    style: style
  }, /*#__PURE__*/_react["default"].createElement("path", {
    ref: innerRef,
    stroke: color,
    fill: "none",
    d: "M200,1.5c-6.89,0-6.89,12-13.79,12c-6.89,0-6.89-12-13.79-12c-6.89,0-6.89,12-13.79,12 c-6.89,0-6.89-12-13.79-12c-6.89,0-6.89,12-13.79,12c-6.89,0-6.89-12-13.79-12c-6.89,0-6.89,12-13.79,12c-6.89,0-6.89-12-13.79-12 c-6.89,0-6.89,12-13.79,12c-6.89,0-6.89-12-13.78-12c-6.89,0-6.89,12-13.79,12c-6.9,0-6.9-12-13.79-12c-6.89,0-6.89,12-13.79,12 c-6.9,0-6.9-12-13.8-12C3.51,1.5,0,7.5,0,7.5"
  }));
}